import { render, staticRenderFns } from "./caseDetails.vue?vue&type=template&id=5d4e0ed6"
import script from "./caseDetails.vue?vue&type=script&lang=js"
export * from "./caseDetails.vue?vue&type=script&lang=js"
import style0 from "./caseDetails.vue?vue&type=style&index=0&id=5d4e0ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports